(function (module) {
    "use strict";

    //@ts-ignore
    module.service("synchronousEventsBus", ['$q', function(this: $TSFixMe, $q: ng.IQService) {
        var service = this;

        var eventMap = {};
        service.$on = function (eventNames: $TSFixMe, callback: $TSFixMe) {
            if (!Array.isArray(eventNames)) {
                eventNames = [eventNames];
            }
            for (const eventName of eventNames) {
                // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                if (eventMap[eventName] != undefined) {
                    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                    eventMap[eventName].push(callback);
                } else {
                    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                    eventMap[eventName] = [callback];
                }
            }
        }

        service.$broadcast = function (eventName: $TSFixMe, args: $TSFixMe) {
            // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            if (eventMap[eventName] != undefined) {
                var promises = [];
                // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                for (const callback of eventMap[eventName]) {
                    var result = callback(eventName, args);
                    if (result != undefined)
                        promises.push($q.when(result));
                }
                if (promises.length == 0)
                    return $q.when();
                else
                    return $q.all(promises);
            }
            return $q.when();
        }
    }]);





})(angular.module("topline.services"));